// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ServiceMetrics_wrapper_3gg5M"};